var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6.25L12.4062 0L0 6.25V7.8125H1.5625V25H4.6875V10.9375H20.3125V25H23.4375V7.8125H25V6.25ZM6.25 9.375V7.8125H9.375V9.375H6.25ZM10.9375 9.375V7.8125H14.0625V9.375H10.9375ZM15.625 9.375V7.8125H18.75V9.375H15.625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 14.0625H7.8125V12.5H6.25V17.1875H10.9375V12.5H9.375V14.0625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 20.3125H7.8125V18.75H6.25V23.4375H10.9375V18.75H9.375V20.3125Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 20.3125H14.0625V18.75H12.5V23.4375H17.1875V18.75H15.625V20.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.43c8961c04f4f0a2e76cb2fdad041244.svg";
export { ForwardRef as ReactComponent };